import {connect} from "react-redux";
import * as InstructorsActions from '../../../store/actions/instructorsActions';
import PeopleInstructors from '../../../components/AdminPanel/People/PeopleInstructors';
import * as CoursesActions from '../../../store/actions/coursesActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.instructors,
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    onLoadCourses: (uid, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, token));
    },
    getInstructors: (token) => {
        dispatch(CoursesActions.getInstructors(token))
    },
    addUserToCourse: (courseUser, token) => {
        dispatch(CoursesActions.addCourseUser(courseUser, token));
    },
    removeCourseUser: (id, token) => {
        dispatch(CoursesActions.removeCourseUser(id, token));
    },
    getInstructorsData: () => {
        dispatch(InstructorsActions.getInstructors());
    },
    instructorDelete: (id) => {
        dispatch(InstructorsActions.deleteInstructor(id));
    },
    editAccessInstructor: (val, id) => {
        dispatch(InstructorsActions.editAccess(val, id));
    },
    editReferralsInstructor: (val, id) => {
        dispatch(InstructorsActions.editReferrals(val, id));
    },
    editCoursesInstructor: (val, id) => {
        dispatch(InstructorsActions.editCourses(val, id))
    },
    updateCourseUser: (courseUser, token) => {
        dispatch(CoursesActions.updateCourseUser(courseUser, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PeopleInstructors);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/People/PeopleInstructorsContainer.js